<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons v-if="routeName != 'profile_insurance_documents' && routeName != 'onboard_insurance_document'" slot="end">
            <ion-button class="pill next-pill-button" @click="skip">
                <span>SKIP</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <div class="main_wrapper ion-padding">
        <div class="container">
            <!-- <page-title title="Proof of Insurance" subtitle="Please upload your documents!" /> -->
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Proof of Insurance</h1>
                    <p class="auth-subtext">Please upload your documents!</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                @submit.prevent="goNext('userForm')">
                <el-form-item class="mb-0" v-if="insuranceFiles.length <= 0">
                    <div class="proof-ins proof-ins--p mb-3">Proof of Insurance</div>
                    <el-upload class="uploader-support" :action="'upload'"
                        :ref="(el) => (formsData.userForm.insuranceFiles.ref = el)" name="insuranceFiles"
                        list-type="picture" :thumbnail-mode="true" :on-preview="cropperProofMethods.handlePreview"
                        :limit="1" :on-exceed="cropperProofMethods.handleExceed" :drag="true"
                        :on-change="cropperProofMethods.handleChange"
                        :before-upload="cropperProofMethods.beforeAvatarUpload">
                        <div class="file-uploader">
                            <div class="file-uploader-icon">
                                <img :src="require('@/assets/img/icons/upload.svg')" alt="upload" />
                            </div>
                            <div class="file-uploader-title">
                                Browse Your Files
                            </div>
                            <div class="file-uploader-description">
                                You can only upload file with JPG JPEG PNG JFIF SVG or PDF formats and
                                also file
                                maximum size 10MB.
                            </div>
                        </div>
                        <template #file="{ file }">
                            <div v-if="file.raw.type == 'application/pdf'" class="el-upload-list__item-body">
                                <img class="el-upload-list__item-body-thumbnail"
                                    :src="require('@/assets/img/icons/pdf.svg')" />
                                <el-form-item prop="otherExpiryDate" class="mb-0" label="Policy expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date"
                                        v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="(date) => handleDateChange(file, date)"
                                        style="width: 100%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-body" v-else>
                                <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                                <el-form-item prop="otherExpiryDate" class="mb-0" label="Policy expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date"
                                        v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="(date) => handleDateChange(file, date)"
                                        style="width: 100%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-actions">
                                <button class="el-upload-list__item-actions-action"
                                    @click.prevent="cropperProofMethods.handleRemove(file)">
                                    <img :src="require('@/assets/img/icons/trash.svg')" />
                                </button>
                            </div>
                        </template>
                    </el-upload>
                    <div class="text-red">(Maximum upload 1 file)</div>
                </el-form-item>



                <el-form-item class="mb-0" v-if="otherInsuranceFiles.length < 3">
                    <div class="proof-ins proof-ins--p mb-3">Other Insurance Documents</div>
                    <el-upload class="uploader-support" :action="'upload'"
                        :ref="(el) => (formsData.userForm.otherInsuranceFiles.ref = el)" name="otherInsuranceFiles"
                        list-type="picture" :thumbnail-mode="true" :on-preview="cropperOthersMethods.handlePreview"
                        :limit="3" :on-exceed="cropperOthersMethods.handleExceed" :drag="true"
                        :on-change="cropperOthersMethods.handleChange"
                        :before-upload="cropperOthersMethods.beforeAvatarUpload">
                        <div class="file-uploader">
                            <div class="file-uploader-icon">
                                <img :src="require('@/assets/img/icons/upload.svg')" alt="upload" />
                            </div>
                            <div class="file-uploader-title">
                                Browse Your Files
                            </div>
                            <div class="file-uploader-description">
                                You can only upload file with JPG JPEG PNG JFIF SVG or PDF formats and
                                also file
                                maximum size 10MB.
                            </div>
                        </div>
                        <template #file="{ file }">
                            <div v-if="file.raw.type == 'application/pdf'" class="el-upload-list__item-body">
                                <img class="el-upload-list__item-body-thumbnail"
                                    :src="require('@/assets/img/icons/pdf.svg')" />
                                <el-form-item prop="otherExpiryDate" class="mb-0" label="Policy expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date"
                                        v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="(date) => handleDateChange(file, date)"
                                        style="width: 100%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-body" v-else>
                                <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                                <el-form-item prop="otherExpiryDate" class="mb-0" label="Policy expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date"
                                        v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="(date) => handleDateChange(file, date)"
                                        style="width: 100%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-actions">
                                <button class="el-upload-list__item-actions-action"
                                    @click.prevent="cropperOthersMethods.handleRemove(file)">
                                    <img :src="require('@/assets/img/icons/trash.svg')" />
                                </button>
                            </div>
                        </template>
                    </el-upload>

                    <div class="text-red mb-3"> (Maximum upload 3 files)</div>
                </el-form-item>




                <el-form-item v-if="insuranceFiles.length <= 0 || otherInsuranceFiles.length < 3"
                    class="button_submit mb0">
                    <el-button :disabled="disabled" class="submit" type="blue" @click="goNext('userForm')">

                        <span v-if="routeName == 'profile_insurance_documents'">Save </span>
                        <span v-else>Continue</span>
                    </el-button>
                </el-form-item>
                <div class="form_text" v-else>
                    <div class="">
                        You have uploaded the max number of documents
                    </div>
                    <el-button class="submit submit-skip" type="blue" @click="goNext('userForm')">

                        <span v-if="routeName == 'profile_insurance_documents'">Save </span>
                        <span v-else>Continue</span>
                    </el-button>
                </div>
            </el-form>
            <div class="bg-overlay"></div>

            <div class="preview_square preview_square--block" v-if="insuranceFiles.length">
                <div>Proof of Insurance</div>
                <div class="el-upload-list">
                    <div class="el-upload-list__item" v-for="(file, index) in insuranceFiles" :key="file.url">
                        <div class="thumbnail_img el-upload-list--picture-card">
                            <div v-if="file.extension == 'pdf'">
                                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">

                            </div>
                            <div v-else>
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            </div>

                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="docPreviewModalOpen(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="fileDelete(file, index, 'proof')">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                        <div v-if="file.expiryDate">
                            <div class="policy-expire">Policy Expiration:</div>
                            <div class="expire-date">
                                {{ $moment(file.expiryDate, "YYYY/MM/DD").format("D MMM, YYYY") }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="preview_square preview_square--block " v-if="otherInsuranceFiles.length">
                <div class="proof-ins">Other Insurance Documents</div>
                <div class="el-upload-list">
                    <div class="el-upload-list__item" v-for="(file, index) in otherInsuranceFiles" :key="file.url">
                        <div class="thumbnail_img el-upload-list--picture-card">
                            <div v-if="file.extension == 'pdf'">
                                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                            </div>
                            <div v-else>
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            </div>
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="docPreviewModalOpen(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="fileDelete(file, index, 'other')">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                        <div v-if="file.expiryDate">
                            <div class="policy-expire">Policy Expiration:</div>
                            <div class="expire-date">

                                {{ $moment(file.expiryDate, "YYYY/MM/DD").format("D MMM, YYYY") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
    <preview-modal :modalName="'previewModal'" :options="previewModal" />
</template>

<script>
import { onMounted, inject, ref } from "vue";
import formHooks from "@/hooks/form/form";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import FileHelpers from "@/helpers/file/file";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import formValidate from "@/hooks/form/validate/validate";
import { useRouter, useRoute } from "vue-router";
import { PreviewModal } from "@/modals/modals";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        "preview-modal": PreviewModal,
        SvgIcon,
    },

    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const routeName = $route.name;
        const BASE_URL = process.env.VUE_APP_BASEURL;
        const userData = $store.getters.GET_USER_DATA;
        const fileHelpers = new FileHelpers();
        const state = userData.address.state;
        let dialogVisible = true;
        let disabled = ref(true);
        const fileList = ref([]);
        const fileDateMap = ref({});
        const $modals = inject("$modals");
        const moment = inject(["$moment"]);
        const previewModal = ref({
            name: "insuranceDocument",
            file: [],
        });
        const docPreviewModalOpen = (file) => {
            if (file.extension == 'pdf') {
                window.open(file.url, '_blank');
            } else {
                previewModal.value.file = file;
                $modals.open("previewModal", {
                    file: file,
                });
            }
        };
        console.log(userData);
        const insuranceFiles = ref(userData.insuranceDocument);
        const otherInsuranceFiles = ref(userData.otherInsuranceDocument);

        const handleDateChange = (file, date) => {
            if (file && file.uid) {
                fileDateMap.value[file.uid] = date;

                // Also update the file object itself for immediate UI update
                if (file.raw) {
                    file.raw.expiryDate = date;
                }
                file.expiryDate = date;
            }
            console.log("Updated file-date mapping:", fileDateMap.value);
        };

        const formsDataArray = {
            userForm: {
                insuranceFiles: {
                    ref: null,
                    value: [],
                    limit: 10,
                    disabled: false,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "gallery",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                    errors: null,
                },
                otherInsuranceFiles: {
                    ref: null,
                    value: [],
                    limit: 10,
                    disabled: false,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "gallery",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                    errors: null,
                },
                proofExpiryDate: {
                    ref: null,
                    value: "",
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    {
                                        rule: "proofExpiryDate",
                                    },
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };
        Object.assign(formsDataArray.userForm, formsDataArray);


        const buildInsurancePayload = () => {
            const formData = new FormData();

            // Handle Proof of Insurance files
            const proofFiles = formsData.userForm.insuranceFiles.value || [];
            proofFiles.forEach((file, index) => {
                if (file && file.raw) {
                    // Add file
                    formData.append(`insuranceFiles[${index}][file]`, file.raw);

                    // Add corresponding date if exists
                    const expiryDate = fileDateMap.value[file.uid] || file.raw.expiryDate;
                    if (expiryDate) {
                        formData.append(`insuranceFiles[${index}][expiry_date]`,
                            moment(expiryDate).format("YYYY-MM-DD"));
                    }

                    // Add file type metadata
                    formData.append(`insuranceFiles[${index}][type]`, 'proof');
                }
            });

            // Handle Other Insurance files
            const otherFiles = formsData.userForm.otherInsuranceFiles.value || [];
            otherFiles.forEach((file, index) => {
                if (file && file.raw) {
                    // Add file
                    formData.append(`otherInsuranceFiles[${index}][file]`, file.raw);

                    // Add corresponding date if exists
                    const expiryDate = fileDateMap.value[file.uid] || file.raw.expiryDate;
                    if (expiryDate) {
                        formData.append(`otherInsuranceFiles[${index}][expiry_date]`,
                            moment(expiryDate).format("YYYY-MM-DD"));
                    }

                    // Add file type metadata
                    formData.append(`otherInsuranceFiles[${index}][type]`, 'other');
                }
            });

            return formData;
        };


        const cropperProofMethods = {
            beforeAvatarUpload(file) {
                const img = URL.createObjectURL(file.raw);
                console.log(img);
            },
            handleRemove(file, event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                console.log('Removing proof file:', file);

                // Remove from the form data array
                if (formsData.userForm.insuranceFiles && Array.isArray(formsData.userForm.insuranceFiles.value)) {
                    const index = formsData.userForm.insuranceFiles.value.findIndex(f => f.uid === file.uid);
                    if (index > -1) {
                        formsData.userForm.insuranceFiles.value.splice(index, 1);
                    }
                }

                // Also remove from any other array references
                if (formsData.userForm.insuranceFiles && Array.isArray(formsData.userForm.insuranceFiles)) {
                    const index = formsData.userForm.insuranceFiles.findIndex(f => f.uid === file.uid);
                    if (index > -1) {
                        formsData.userForm.insuranceFiles.splice(index, 1);
                    }
                }

                // Clean up date mapping if exists
                if (fileDateMap.value && file.uid && fileDateMap.value[file.uid]) {
                    delete fileDateMap.value[file.uid];
                }

                console.log('Proof files after removal:', formsData.userForm.insuranceFiles);
                onChangeUpload();

                return false; // Prevent default
            },
            handleChange(file, files) {
                const type = fileHelpers.getFileType(file);

                if (type == "image" || type == "pdf") {
                    formsData.userForm.insuranceFiles = files;
                    formsData.userForm.insuranceFiles.value = files;
                    console.log("proof ko main", formsData.userForm.insuranceFiles.value);
                    checkFormValidation("userForm", true, "files");
                } else {
                    files.pop();
                    formsData.userForm.insuranceFiles.value = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
                onChangeUpload();
            },

            handlePreview(/*file*/) { },
            handleExceed(file, files) {
                console.log(file);
                ElMessage({
                    type: "error",
                    message: `You can upload 1 document, you selected ${files.length} `,
                });
            },
        };

        const onChangeUpload = () => {
            if (formsData.userForm.insuranceFiles.value.length > 0 || formsData.userForm.otherInsuranceFiles.value.length > 0) {
                disabled.value = false;
            } else {
                disabled.value = true;
            }
        };

        const cropperOthersMethods = {
            beforeAvatarUpload(file) {
                const img = URL.createObjectURL(file.raw);
                console.log(img);
            },
            handleRemove(file, event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                console.log('Removing other insurance file:', file);

                // Remove from the form data array
                if (formsData.userForm.otherInsuranceFiles && Array.isArray(formsData.userForm.otherInsuranceFiles.value)) {
                    const index = formsData.userForm.otherInsuranceFiles.value.findIndex(f => f.uid === file.uid);
                    if (index > -1) {
                        formsData.userForm.otherInsuranceFiles.value.splice(index, 1);
                    }
                }

                // Also remove from any other array references
                if (formsData.userForm.otherInsuranceFiles && Array.isArray(formsData.userForm.otherInsuranceFiles)) {
                    const index = formsData.userForm.otherInsuranceFiles.findIndex(f => f.uid === file.uid);
                    if (index > -1) {
                        formsData.userForm.otherInsuranceFiles.splice(index, 1);
                    }
                }

                // Clean up date mapping if exists
                if (fileDateMap.value && file.uid && fileDateMap.value[file.uid]) {
                    delete fileDateMap.value[file.uid];
                }

                // Also remove from fileList if it exists there
                if (fileList.value && Array.isArray(fileList.value)) {
                    const fileListIndex = fileList.value.findIndex(f => f.uid === file.uid);
                    if (fileListIndex > -1) {
                        fileList.value.splice(fileListIndex, 1);
                    }
                }

                console.log('Other files after removal:', formsData.userForm.otherInsuranceFiles);
                onChangeUpload();

                return false; // Prevent default
            },
            handleChange(file, files) {
                const type = fileHelpers.getFileType(file);
                console.log(type);
                if (type == "image" || type == "pdf") {
                    formsData.userForm.otherInsuranceFiles = files;
                    formsData.userForm.otherInsuranceFiles.value = files;
                    checkFormValidation("userForm", true, "files");
                } else {
                    files.pop();
                    formsData.userForm.otherInsuranceFiles.value = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
                onChangeUpload();
            },

            handlePreview(/*file*/) { },
            handleExceed(file, files) {
                console.log(file);
                ElMessage({
                    type: "error",
                    message: `You can upload 3 documents, you selected ${files.length} `,
                });
            },
        };

        const goBack = () => {
            if (routeName == "profile_insurance_documents") {
                $router.push({
                    name: "profile_documents",
                });
            } else if (routeName == "onboard_insurance_document") {
                $router.push({
                    name: "onboard_identity_document",
                });

            } else {
                $router.push({
                    name: "identity_document",
                });
            }


        };

        const goNext = (formName) => {
            if (routeName !== "profile_insurance_documents") {
                if (insuranceFiles.value.length > 0 || otherInsuranceFiles.value.length > 0) {
                    skip();
                    return;
                }
            }

            console.log("insurance length", insuranceFiles.value.length);
            formsRefs[formName].value.validate(async (valid) => {
                if (valid) {
                    try {
                        const payload = buildInsurancePayload();
                        console.log("FormData payload:", payload);

                        // Log all entries for debugging
                        for (let [key, value] of payload.entries()) {
                            console.log(`${key}:`, value);
                        }

                        await $store.dispatch("SAVE_USER_INSURSNCE_DOCUMENT", payload);

                        // Handle success response and navigation
                        handleSuccessNavigation();

                    } catch (error) {
                        console.error("Error submitting insurance documents:", error);
                        handleSubmissionError(error);
                    }
                }
            });
        };


        const handleSuccessNavigation = () => {
            // Clear form data
            clearFormData();

            // Update local state with fresh data
            const getUserData = $store.getters.GET_USER_DATA;
            insuranceFiles.value = getUserData.insuranceDocument;
            otherInsuranceFiles.value = getUserData.otherInsuranceDocument;

            // Navigate based on route
            if (routeName == "profile_insurance_documents") {
                return;
            } else if (routeName == "onboard_insurance_document") {
                $router.push({ name: "onboard_cv_upload" });
            } else {
                handleRegularUserNavigation();
            }
        };

        const clearFormData = () => {
            // Clear upload components
            if (formsData.userForm.otherInsuranceFiles?.ref?.clearFiles) {
                formsData.userForm.otherInsuranceFiles.ref.clearFiles();
            }
            if (formsData.userForm.insuranceFiles?.ref?.clearFiles) {
                formsData.userForm.insuranceFiles.ref.clearFiles();
            }

            // Reset form values
            formsData.userForm.otherInsuranceFiles = [];
            formsData.userForm.insuranceFiles = [];

            // Clear date mappings
            fileDateMap.value = {};
        };

        const handleRegularUserNavigation = () => {
            if (userData.role === 'locum' && userData.contractorOnboarding) {
                $store.dispatch("SAVE_USER_DATA", {
                    survey: 1,
                    hideLoading: true,
                });
                $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                $router.push({ name: "intro" });
            } else {
                $router.push({ name: "cv_upload" });
            }
        };

        const handleSubmissionError = (error) => {
            if (error && typeof error === 'object') {
                for (let key in error) {
                    if (Array.isArray(error[key])) {
                        ElMessage({
                            showClose: true,
                            type: "error",
                            message: error[key][0],
                        });
                    }
                }
            } else {
                ElMessage({
                    showClose: true,
                    type: "error",
                    message: "An error occurred while saving documents",
                });
            }
        };


        const skip = () => {
            $store.dispatch("addAuthPageBack", $route.name);
            if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                $store.dispatch("SAVE_USER_DATA", {
                    survey: 1,
                    hideLoading: true,
                });
                $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                $router.push({
                    name: "intro",
                });
            } else {
                // $store.dispatch('SAVE_USER_DATA', {
                //   survey: 1,
                //   hideLoading: true
                //   });
                if (routeName == "profile_insurance_documents") {
                    return;
                } else if (routeName == "onboard_insurance_document") {
                    $router.push({
                        name: "onboard_cv_upload",
                    });

                } else {
                    $router.push({
                        name: "cv_upload",
                    });
                }
            }
          
        };


        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            checkFormValidation("userForm", false);
            setFormRefs();
            console.log("size other", otherInsuranceFiles.value.length);
            console.log("size proof", insuranceFiles.value.length);

            if (insuranceFiles.value.length > 0 || otherInsuranceFiles.value.length > 0) {
                disabled.value = false;
            }
        });

        const fileDelete = async (file, index, fileTag) => {
            try {
                console.log("deleted files", file);
                await ElMessageBox.confirm(
                    `Are you sure you’d like to remove file ?`,
                    "Remove file",
                    {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                    }
                );
                await $store.dispatch("DELETE_USER_DOCUMENT", file);
                if (fileTag == 'proof') {

                    insuranceFiles.value.splice(index, 1);
                } else {
                    otherInsuranceFiles.value.splice(index, 1);
                }
            } catch (error) {
                console.log(error);
            }
        };

        const {
            checkFormValidation,
            setFormValidation,
            formsRefs,
            setFormRefs,
            getFormValues,
            formsData,
        } = formHooks(formsDataArray);

        return {
            formsData,
            goBack,
            goNext,
            checkFormValidation,
            routeName,
            cropperProofMethods,
            cropperOthersMethods,
            fileDelete,
            insuranceFiles,
            otherInsuranceFiles,
            state,
            BASE_URL,
            getFormValues,
            docPreviewModalOpen,
            previewModal,
            dialogVisible,
            skip,
            disabled,
            onChangeUpload,
            handleDateChange,
            fileList,
            fileDateMap,
            formatDate: (date) => {
                return moment(date).format('ll');
            }
        };
    },
};
</script>
